NtechApp.MapControls = function($view) {
    var me = this;

    this._$view = null;
    this._click = null;
    this._ajax = null;
    this._zipSelect = null;

    this._zipCodeAuto = null;
    this._cityAuto = null;
    this._restaurantAuto = null;

    this._zipCodeId = null;
    this._distance = null;
    this._cityId = null;

    this._isZipEnabled = null;
    this._currentSelectInputVal = null;

    this._construct = function () {
        me._$view = $view;
        me._click = new NtechApp.TouchClickEvent();
        me._ajax = new NtechApp.Ajax();
        me._zipSelect = new NtechApp.SelectForm(me._$view.find("[data-zipDistanceControl]"));

        me._zipCodeAuto = new NtechApp.Autocomplete(
            me._$view.find(".zipCodeAuto"),
            NtechApp.merge(
                NtechApp.autocompleteSettings.default,
                {matchType: NtechApp.Autocomplete.MATCH_TYPES.START}
            ),
            function() { me._loadZipCodes.apply(me, arguments); }
        );
        me._cityAuto = new NtechApp.Autocomplete(
            me._$view.find(".cityAuto"),
            NtechApp.merge(
                NtechApp.autocompleteSettings.default,
                {matchType: NtechApp.Autocomplete.MATCH_TYPES.START}
            ),
            function() { me._loadCities.apply(me, arguments); }
        );

        var restaurantAutoSettings = NtechApp.merge(
            NtechApp.autocompleteSettings.default,
            {matchType: NtechApp.Autocomplete.MATCH_TYPES.FULL}
        );
        restaurantAutoSettings.getWidth = function($input) {
            return 400;
        };
        me._restaurantAuto = new NtechApp.Autocomplete(
            me._$view.find(".restaurantAuto"),
            restaurantAutoSettings,
            function() { me._loadRestaurants.apply(me, arguments); }
        );

        me._bindEvents();
        me.disableZipDistance();
    }

    this._bindEvents = function () {
        me._bindSharedEvents();
        me._bindZipAutoEvents();
        me._bindCityAutoEvents();
        me._bindRestaurantAutoEvents();
    }

    this._bindSharedEvents = function() {
        me._$view.find("[data-zipDistanceControl]").on("change", function(event) {
            me._distance = parseFloat($(this).val());
            me._triggerZipControlChangeEvent();
        });

        me._click.listen(me._$view.find(".selectInputWrapper").parent(), function() {
            if(!me.isZipDistanceEnabled()) {
                NtechApp.info.on("Please enter zip code before selecting distance.", 2500);
                return;
            }

            me._zipSelect.on();
        });

        me._click.listen(me._$view.find(".activeInput"), function(event) {
            var $target = $(event.target).closest(".activeInput");
            var $input = $target.find("input");

            if($input.css("display") != "hidden")
                $input.focus();
        });

        //me._$view.find(".disabledInputOverlay").on(NtechApp.MapControls.EVENT_MOUSEENTER, function() {
        //    $(this).siblings("select").addClass("selectedInput");
        //});
        //
        //me._$view.find(".disabledInputOverlay").on(NtechApp.MapControls.EVENT_MOUSELEAVE, function() {
        //    $(this).siblings("select").removeClass("selectedInput");
        //});

        me._$view.find(".icon").on(NtechApp.MapControls.EVENT_MOUSEENTER, function() {
            $(this).siblings("input").addClass("selectedInput");
            $(this).siblings(".selectInputWrapper").find("input").addClass("selectedInput");
        });

        me._$view.find(".icon").on(NtechApp.MapControls.EVENT_MOUSELEAVE, function() {
            $(this).siblings("input").removeClass("selectedInput");
            $(this).siblings(".selectInputWrapper").find("input").removeClass("selectedInput");
        });
    }

    this._bindZipAutoEvents = function() {
        $(me._zipCodeAuto).on(NtechApp.Autocomplete.SELECT_EVENT, function(event, id, text, $searchResult) {
            me._zipCodeId = id;
            me._distance = me._$view.find("[data-zipDistanceControl]").val();
            // @todo -> Rewrite select to use hidden input(+remove restrictTrigger param)
            if(!NtechApp.isNumeric(me._distance))
                me._distance = NtechApp.MapControls.DEFAULT_DISTANCE;
            me._distance = parseFloat(me._distance);

            me._triggerZipControlChangeEvent();
        });

        me._click.listen(me._zipCodeAuto.getView(), "[data-loadNextSearchResults]", function(event) {
            if($(event.target).hasClass("lockLoadNextButton"))
                return;

            var $loadNext = $(event.target).addClass("selectedItem lockLoadNextButton");
            var page = $loadNext.attr("data-loadNextSearchResults");

            me._ajax.enableTextLoading($loadNext);
            me._loadZipCodes(
                me._zipCodeAuto.getSearchVal(),
                NtechApp.bind("appendData", me._zipCodeAuto),
                NtechApp.noop,
                page
            );
        });
    }

    this._bindCityAutoEvents = function() {
        $(me._cityAuto).on(NtechApp.Autocomplete.SELECT_EVENT, function(event, id, text, $searchResult) {
            me._cityId = id;
            me._triggerCityControlChangeEvent();
        });

        me._click.listen(me._cityAuto.getView(), "[data-loadNextSearchResults]", function(event) {
            if($(event.target).hasClass("lockLoadNextButton"))
                return;

            var $loadNext = $(event.target).addClass("selectedItem lockLoadNextButton");
            var page = $loadNext.attr("data-loadNextSearchResults");

            me._ajax.enableTextLoading($loadNext);
            me._loadCities(
                me._cityAuto.getSearchVal(),
                NtechApp.bind("appendData", me._cityAuto),
                NtechApp.noop,
                page
            );
        });
    }

    this._bindRestaurantAutoEvents = function() {
        me._click.listen(me._restaurantAuto.getView(), "[data-loadNextSearchResults]", function(event) {
            if($(event.target).hasClass("lockLoadNextButton"))
                return;

            var $loadNext = $(event.target).addClass("selectedItem lockLoadNextButton");
            var page = $loadNext.attr("data-loadNextSearchResults");

            me._ajax.enableTextLoading($loadNext);
            me._loadRestaurants(
                me._restaurantAuto.getSearchVal(),
                NtechApp.bind("appendData", me._restaurantAuto),
                NtechApp.noop,
                page
            );
        });
    }

    this._unbindEvents = function () {
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.MapControls.EVENT_ZIP_CONTROL_CHANGE = "NtechApp.MapControls.EventZipControlSelect";
NtechApp.MapControls.EVENT_CITY_CONTROL_CHANGE = "NtechApp.MapControls.EventCityChange";
NtechApp.MapControls.EVENT_MOUSEENTER = "mouseenter.NtechApp.MapControls";
NtechApp.MapControls.EVENT_MOUSELEAVE = "mouseleave.NtechApp.MapControls";
NtechApp.MapControls.DEFAULT_DISTANCE = 5;

NtechApp.proto(NtechApp.MapControls, {
    getView: function() {
        return this._$view;
    },

    isZipDistanceEnabled: function() {
        //return this._$view.find("[data-zipDistanceControl]).css("display") == "block";
        return this._isZipEnabled;
    },

    enableZipDistance: function() {
        //this._$view.find("[data-zipDistanceControl]").css("display", "block");
        //this._$view.find(".disabledZipDistance").css("display", "none");
        //this._$view.find("[data-zipDistanceControl]").siblings(".disabledInputOverlay").css("display", "none");
        this._isZipEnabled = true;
        var $zipSelect = this._zipSelect.getSelectInput();

        $zipSelect.attr("placeholder", "");
        this._zipSelect.setSelected("5 miles", "5", true);
    },

    disableZipDistance: function() {
        //this._$view.find("[data-zipDistanceControl]").css("display", "none");
        //this._$view.find(".disabledZipDistance").css("display", "block");
        //this._$view.find("[data-zipDistanceControl]").siblings(".disabledInputOverlay").css("display", "block");
        this._isZipEnabled = false;
        var $zipSelect = this._zipSelect.getSelectInput();

        $zipSelect.attr("placeholder", "Enter zip");
        this._zipSelect.setSelected("", "", true);
    },

    _loadZipCodes: function(searchVal, onFoundData, onNotFoundData, page) {
        var me = this;
        var params = {
            searchType: NtechApp.searchTypes.ZIP_CODES,
            searchText: searchVal,
            searchPage: page || 0
        };

        me._ajax.get({
            url: Routing.generate('search', params),
            onSuccess: function(data) {
                if(data.hasResults)
                    onFoundData(data.html);
                else
                    onNotFoundData(data.html);
            },
            onComplete: function() {
                //if(me._nextLoadRequestData == null)
                //    me._loaderOff();
            }
        });
    },

    _triggerZipControlChangeEvent: function() {
        if(!this.isZipDistanceEnabled())
            this.enableZipDistance();

        $(this).trigger(NtechApp.MapControls.EVENT_ZIP_CONTROL_CHANGE, [
            this._zipCodeId, this._distance
        ]);
    },

    _loadCities: function(searchVal, onFoundData, onNotFoundData, page) {
        var me = this;
        var params = {
            searchType: NtechApp.searchTypes.CITIES,
            searchText: searchVal,
            searchPage: page || 0
        };

        me._ajax.get({
            url: Routing.generate('search', params),
            onSuccess: function(data) {
                if(data.hasResults)
                    onFoundData(data.html);
                else
                    onNotFoundData(data.html);
            },
            onComplete: function() {
                ;
            }
        });
    },

    _triggerCityControlChangeEvent: function() {
        this.disableZipDistance();
        $(this).trigger(NtechApp.MapControls.EVENT_CITY_CONTROL_CHANGE, [
            this._cityId
        ]);
    },

    _loadRestaurants: function(searchVal, onFoundData, onNotFoundData, page) {
        var me = this;
        var params = {
            searchType: NtechApp.searchTypes.RESTAURANTS,
            searchText: searchVal,
            searchPage: page || 0
        };

        me._ajax.get({
            url: Routing.generate('search', params),
            onSuccess: function(data) {
                if(data.hasResults)
                    onFoundData(data.html);
                else
                    onNotFoundData(data.html);
            },
            onComplete: function() {
                ;
            }
        });
    }
});